import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const styles = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
        color: "#e7e7e9",
        padding: "48px 16px 72px",
        fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
    },
    container: {
        maxWidth: "1080px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "28px",
    },
    card: {
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.07)",
        boxShadow: "0 24px 48px rgba(0,0,0,0.3)",
        borderRadius: "18px",
        padding: "24px",
        backdropFilter: "blur(4px)",
    },
    hero: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "16px",
        padding: "8px 4px",
    },
    title: {
        fontSize: "32px",
        fontWeight: 800,
        letterSpacing: "-0.04em",
        color: "#fff",
        margin: 0,
    },
    subtitle: {
        marginTop: "8px",
        color: "#cbd5e1",
        fontSize: "15px",
        lineHeight: 1.4,
    },
    badge: {
        background: "linear-gradient(120deg, #f97316, #f59e0b)",
        color: "#0f0a09",
        padding: "8px 14px",
        borderRadius: "999px",
        fontWeight: 700,
        fontSize: "13px",
        border: "1px solid rgba(255,255,255,0.15)",
    },
    noticeHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "14px",
    },
    noticeList: {
        listStyle: "none",
        padding: 0,
        margin: 0,
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    },
    noticeItem: {
        padding: "14px 16px",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.03)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        transition: "transform 0.15s ease, border-color 0.2s ease",
    },
    noticeItemHover: {
        borderColor: "rgba(255,255,255,0.16)",
        transform: "translateY(-2px)",
    },
    noticeTitle: {
        color: "#ef4444",
        fontWeight: 700,
        fontSize: "15px",
        letterSpacing: "-0.01em",
    },
    noticeDate: {
        color: "#cbd5e1",
        fontSize: "13px",
    },
    moreLink: {
        color: "#fb923c",
        fontWeight: 600,
        textDecoration: "none",
    },
    buttonRow: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
        gap: "12px",
    },
    primaryButton: {
        padding: "16px 18px",
        borderRadius: "14px",
        border: "1px solid rgba(255,255,255,0.14)",
        color: "#130903",
        fontWeight: 800,
        fontSize: "16px",
        textAlign: "center",
        textDecoration: "none",
        background: "linear-gradient(120deg, #fb923c, #f97316)",
        boxShadow: "0 12px 30px rgba(249,115,22,0.28)",
        transition: "transform 0.15s ease, box-shadow 0.2s ease",
    },
    adCard: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },
    adRow: {
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: "14px",
    },
    adTile: {
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: "14px",
        overflow: "hidden",
        background: "rgba(255,255,255,0.04)",
        display: "grid",
        gridTemplateRows: "minmax(180px, 1fr) auto",
        minHeight: "240px",
        transition: "transform 0.18s ease, box-shadow 0.2s ease",
        boxShadow: "0 16px 30px rgba(0,0,0,0.28)",
    },
    adPlaceholder: {
        minHeight: "240px",
        borderRadius: "14px",
        border: "1px dashed rgba(255,255,255,0.08)",
        background: "rgba(255,255,255,0.02)",
    },
    adTileHover: {
        transform: "translateY(-3px)",
        boxShadow: "0 22px 38px rgba(0,0,0,0.36)",
        borderColor: "rgba(249,115,22,0.35)",
    },
    adImageWrap: {
        background: "rgba(15,10,8,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "8px",
        height: "clamp(180px, 24vw, 280px)",
    },
    adImage: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        display: "block",
    },
    adBody: {
        padding: "14px 16px 16px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    adTitle: {
        color: "#f8fafc",
        fontWeight: 700,
        fontSize: "16px",
        lineHeight: 1.3,
    },
    adDesc: {
        color: "#cbd5e1",
        fontSize: "13px",
        lineHeight: 1.5,
        flex: 1,
    },
    adCta: {
        color: "#fb923c",
        fontWeight: 700,
        fontSize: "13px",
        textDecoration: "none",
    },
    dots: {
        display: "flex",
        gap: "8px",
        justifyContent: "center",
        marginTop: "4px",
    },
    dot: {
        width: "9px",
        height: "9px",
        borderRadius: "999px",
        background: "rgba(255,255,255,0.18)",
        border: "1px solid rgba(255,255,255,0.12)",
    },
    dotActive: {
        background: "#fb923c",
        boxShadow: "0 0 0 6px rgba(249,115,22,0.16)",
    },
};

const Main = () => {
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ads, setAds] = useState([]);
    const [adsLoading, setAdsLoading] = useState(true);
    const [adDuration, setAdDuration] = useState(8); // 슬라이드 전환 시간(초)
    const [adPage, setAdPage] = useState(0); // 현재 페이지 인덱스
    const [adCols, setAdCols] = useState(2); // 데스크톱 2, 모바일 1

    useEffect(() => {
        const fetchNotices = async () => {
            try {
                const res = await fetch("/notices");
                const data = await res.json();

                // 배열 형태이든 객체 형태이든 안전하게 처리
                const noticeArray = Array.isArray(data)
                    ? data
                    : Array.isArray(data.notices)
                    ? data.notices
                    : [];

                // 최신순 정렬 후 5개만 표시
                const latestFive = noticeArray
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                    .slice(0, 5);

                setNotices(latestFive);
            } catch (error) {
                console.error("공지사항 불러오기 오류:", error);
            } finally {
                setLoading(false);
            }
        };

        const fetchAds = async () => {
            try {
                const res = await fetch("/ads");
                const data = await res.json();

                const adArray = Array.isArray(data)
                    ? data
                    : Array.isArray(data.ads)
                    ? data.ads
                    : [];

                setAds(adArray);

                // 서버에서 duration을 내려줄 경우 반영 (초 단위)
                const serverDuration =
                    (typeof data.duration === "number" && data.duration > 0 && data.duration) ||
                    (typeof data.ad_duration === "number" && data.ad_duration > 0 && data.ad_duration);
                if (serverDuration) setAdDuration(serverDuration);
            } catch (error) {
                console.error("광고 불러오기 오류:", error);
            } finally {
                setAdsLoading(false);
            }
        };

        fetchNotices();
        fetchAds();
    }, []);

    // 광고 데이터가 바뀌면 첫 페이지로 초기화
    useEffect(() => {
        setAdPage(0);
    }, [ads]);

    // 반응형: 모바일 1컬럼, 데스크톱 2컬럼
    useEffect(() => {
        const handleResize = () => {
            setAdCols(window.innerWidth < 768 ? 1 : 2);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // 광고 데이터가 바뀌면 첫 페이지로 초기화
    useEffect(() => {
        setAdPage(0);
    }, [ads, adCols]);

    const formatDate = (value) => {
        if (!value) return "";
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? "" : date.toLocaleDateString();
    };

    // 슬라이드 자동 전환
    useEffect(() => {
        const pageSize = Math.max(1, adCols);
        const pages = Math.max(1, Math.ceil(ads.length / pageSize));
        if (pages <= 1) return;
        const timer = setInterval(() => {
            setAdPage((prev) => (prev + 1) % pages);
        }, adDuration * 1000);
        return () => clearInterval(timer);
    }, [ads, adDuration, adCols]);

    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={{ ...styles.card, ...styles.hero }}>
                    <div>
                        <div style={styles.badge}>NEXT GEN AUTO TRADING</div>
                        <h1 style={styles.title}>Speed BOT</h1>
                        <p style={styles.subtitle}>
                            실시간 시그널·자동매매·위험 관리까지 한 화면에서. <br />
                            더 깔끔해진 홈에서 바로 시작해 보세요.
                        </p>
                    </div>
                </div>

                {/* 공지사항 영역 */}
                <div style={styles.card}>
                    <div style={styles.noticeHeader}>
                        <h2 style={{ margin: 0, fontSize: "20px", color: "#fff" }}>공지사항</h2>
                        <Link to="/Notices" style={styles.moreLink}>
                            더보기 →
                        </Link>
                    </div>

                    {loading ? (
                        <p style={styles.helper}>공지사항을 불러오는 중입니다...</p>
                    ) : notices.length === 0 ? (
                        <p style={styles.helper}>등록된 공지사항이 없습니다.</p>
                    ) : (
                        <ul style={styles.noticeList}>
                            {notices.map((notice) => (
                                <li
                                    key={notice.id}
                                    style={styles.noticeItem}
                                    onMouseEnter={(e) =>
                                        Object.assign(e.currentTarget.style, styles.noticeItemHover)
                                    }
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "none";
                                        e.currentTarget.style.borderColor = styles.noticeItem.border
                                            .split(":")[1]
                                            .trim();
                                    }}
                                >
                                    <Link
                                        to={`/Notice/${notice.id}`}
                                        style={{
                                            display: "flex",
                                            width: "100%",
                                            justifyContent: "space-between",
                                            textDecoration: "none",
                                            alignItems: "center",
                                        }}
                                    >
                                        <span style={styles.noticeTitle}>{notice.title}</span>
                                        {notice.created_at && (
                                            <span style={styles.noticeDate}>
                                                {formatDate(notice.created_at)}
                                            </span>
                                        )}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* 주요 액션 버튼 */}
                <div style={{ ...styles.card, ...styles.buttonRow }}>
                    <Link to="/SignupAts" style={styles.primaryButton}>
                        Sign up
                    </Link>
                    <Link to="/LoginAts" style={styles.primaryButton}>
                        Log in
                    </Link>
                    <Link to="/SelectPage" style={styles.primaryButton}>
                        Select Page
                    </Link>
                </div>

                {/* 광고 영역: 외부에서 업로드된 광고를 2개씩 슬라이드로 노출 */}
                <div style={{ ...styles.card, ...styles.adCard }}>
                    <div style={styles.noticeHeader}>
                        <h3 style={{ margin: 0, color: "#fff" }}>파트너</h3>
                    </div>

                    {adsLoading ? (
                        <p style={styles.helper}>불러오는 중입니다...</p>
                    ) : ads.length === 0 ? (
                        <p style={styles.helper}>현재 등록된 정보가 없습니다.</p>
                    ) : (
                        <>
                            {(() => {
                                const pageSize = Math.max(1, adCols);
                                const start = adPage * pageSize;
                                const current = ads.slice(start, start + pageSize);
                                const slots =
                                    adCols > 1 && current.length < pageSize
                                        ? [...current, ...Array(pageSize - current.length).fill(null)]
                                        : current;
                                const adRowStyle = { ...styles.adRow, gridTemplateColumns: `repeat(${pageSize}, minmax(0, 1fr))` };
                                return (
                                    <div style={adRowStyle}>
                                        {slots.map((ad, idx) =>
                                            ad ? (
                                                <a
                                                    key={ad.id || ad.link || ad.image_url || idx}
                                                    href={ad.link || "#"}
                                                    target={ad.link ? "_blank" : "_self"}
                                                    rel="noreferrer"
                                                    style={{ textDecoration: "none" }}
                                                    onMouseEnter={(e) =>
                                                        Object.assign(e.currentTarget.firstChild.style, styles.adTileHover)
                                                    }
                                                    onMouseLeave={(e) => {
                                                        const tile = e.currentTarget.firstChild;
                                                        tile.style.transform = "none";
                                                        tile.style.boxShadow = styles.adTile.boxShadow;
                                                        const borderParts = (styles.adTile.border || "").split(":");
                                                        tile.style.borderColor = borderParts[1] ? borderParts[1].trim() : "transparent";
                                                    }}
                                                >
                                                    <div style={styles.adTile}>
                                                        <div style={styles.adImageWrap}>
                                                            {ad.image_url ? (
                                                                <img
                                                                    src={ad.image_url}
                                                                    alt={ad.title || "광고"}
                                                                    style={styles.adImage}
                                                                />
                                                            ) : (
                                                                <div
                                                                    style={{
                                                                        ...styles.adImage,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        color: "#cbd5e1",
                                                                        fontSize: "13px",
                                                                        background: "rgba(255,255,255,0.03)",
                                                                    }}
                                                                >
                                                                    이미지가 없습니다
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div style={styles.adBody}>
                                                            <div style={styles.adTitle}>{ad.title || "제목 없음"}</div>
                                                            <div style={styles.adDesc}>
                                                                {ad.description || "설명이 제공되지 않았습니다."}
                                                            </div>
                                                            {ad.link && <span style={styles.adCta}>바로가기 →</span>}
                                                        </div>
                                                    </div>
                                                </a>
                                            ) : (
                                                <div key={`placeholder-${idx}`} style={styles.adPlaceholder} />
                                            )
                                        )}
                                    </div>
                                );
                            })()}

                            {Math.ceil(ads.length / Math.max(1, adCols)) > 1 && (
                                <div style={styles.dots}>
                                    {Array.from({ length: Math.ceil(ads.length / Math.max(1, adCols)) }).map((_, idx) => (
                                        <span
                                            key={idx}
                                            style={{
                                                ...styles.dot,
                                                ...(idx === adPage ? styles.dotActive : {}),
                                            }}
                                        />
                                    ))}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Main;
